export function paginateTable(table) {
  if (["server", "none"].includes(table.dataset.pagination)) return () => {};
  const nav = document.createElement("nav");
  nav.className = "table-pagination";
  nav.setAttribute("aria-label", "Pagination du tableau");
  const summary = document.createElement("span");
  summary.setAttribute("aria-live", "polite");
  const label = document.createElement("label");
  label.textContent = "Lignes par page ";
  const select = document.createElement("select");
  [10, 25, 50, 100].forEach(size => {
    const option = document.createElement("option");
    option.value = size;
    option.textContent = size;
    select.append(option);
  });
  label.append(select);
  const previous = document.createElement("button");
  previous.type = "button";
  previous.textContent = "Précédent";
  const next = document.createElement("button");
  next.type = "button";
  next.textContent = "Suivant";
  const pageLabel = document.createElement("span");
  nav.append(summary, label, previous, pageLabel, next);
  table.after(nav);
  let page = 1;
  let size = 10;
  let signature = "";
  const update = () => {
    const rows = Array.from(table.tBodies).flatMap(body => Array.from(body.rows)).filter(row => !row.querySelector(".app-table-message"));
    const nextSignature = rows.map(row => row.textContent).join("\u0000");
    if (signature !== nextSignature) page = 1;
    signature = nextSignature;
    const pages = Math.max(1, Math.ceil(rows.length / size));
    page = Math.min(page, pages);
    rows.forEach((row, index) => { row.hidden = index < (page - 1) * size || index >= page * size; });
    const text = rows.length ? `${(page - 1) * size + 1}–${Math.min(page * size, rows.length)} sur ${rows.length}` : "0 résultat";
    if (summary.textContent !== text) summary.textContent = text;
    const position = `Page ${page} / ${pages}`;
    if (pageLabel.textContent !== position) pageLabel.textContent = position;
    previous.disabled = page === 1;
    next.disabled = page === pages;
    nav.hidden = rows.length === 0;
  };
  previous.onclick = () => { page--; update(); };
  next.onclick = () => { page++; update(); };
  select.onchange = () => { size = Number(select.value); page = 1; update(); };
  return { update, destroy: () => { nav.remove(); Array.from(table.tBodies).forEach(body => Array.from(body.rows).forEach(row => { row.hidden = false; })); } };
}
